import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var LOCKY_GROUP = 'data-locky-group';
var LOCKY_TRANSPARENT = 'data-locky-transparent';

var getAllInGroup = function getAllInGroup(node) {
  var group = node.getAttribute(LOCKY_GROUP);

  if (group) {
    return _toConsumableArray(document.querySelectorAll("[".concat(LOCKY_GROUP, "=\"").concat(group, "\"]")));
  }

  return [node];
};

export var isInside = function isInside(ref, target) {
  var all = getAllInGroup(ref);
  return !!all.find(function (node) {
    return node.contains(target);
  });
};
export var isInsideCurrent = function isInsideCurrent(ref, target) {
  return ref.contains(target);
};
export var isLastInGroup = function isLastInGroup(ref) {
  var refs = getAllInGroup(ref);
  return refs[refs.length - 1] === ref;
};
export var shouldIgnoreEvent = function shouldIgnoreEvent(eventNode) {
  var freeNodes = _toConsumableArray(document.querySelectorAll("[".concat(LOCKY_TRANSPARENT, "=\"true\"]")));

  return freeNodes.some(function (node) {
    return node.contains(eventNode);
  });
};